import DataInvoice from "./DataInvoice";

export default function DataPaidInvoice({ row, index }) {
  return <DataInvoice row={row} index={index} active="paid" />;
}
